import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { sendAPIRequest, generateOptionsFromData, displayNotification } from "../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../redux/generalSlice";
import { useTranslation } from "react-i18next";
import AutoCompleteDropdown from "../../../components/autocomplete/AutoCompleteDropdown";
import Crumbs from "components/crumbs/Crumbs";
import TextFieldCustom from "components/TextFieldCustom";
import { useNavigate } from "react-router-dom";
import uploadImage from '../../../images/upload.png';
import uploadDarkImage from '../../../images/upload_dark.png';
import { BsDownload } from "react-icons/bs";
const Form = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    const [fileName, setFileName] = useState('');
    const fileRef = useRef();
    const [isDownload, setIsDownload] = useState(false)
    const userId = useSelector((s) => s.auth.data.id);
    const initialForm = {
        indicator_name: "",
        indicator_description: "",
        indicator_use_purpose: "",
        attachment: "",
    };

    const [form, setForm] = useState({ ...initialForm });
    const [file, setFile] = useState(null);
    const [checkRequestSent, setRequestSent] = useState(false);
    const { t } = useTranslation();
    const [pdfs, setPDFS] = useState('');
    useEffect(() => {
        if (id) {
            loadData();
        }
    }, [id]);
    console.log("file", file);
    // console.log("fileData", file.data);
    // console.log("fileNmae", file.name);

    // console.log("form", form);

    function validator() {
        if (form.indicator_name === "") {
            displayNotification("error", t("-1", "Please enter Indicator Name"));
            return false;
        }
        if (form.indicator_description === "") {
            displayNotification("error", t("-1", "Please enter Indicator Description"));
            return false;
        }
        if (form.indicator_use_purpose === "") {
            displayNotification("error", t("-1", "Please enter Indicator Use Purpose"));
            return false;
        }
        return true;
    }

    const _downloadFile = async () => {
        try {
            // Adding a cache-busting query parameter to the URL
            const timestamp = new Date().getTime();
            const response = await fetch(`/api/indicator/download/1?_=${timestamp}`);
            console.log("response:", response)
            if (!response.ok) {
                throw new Error('Error downloading file');
            }

            setIsDownload(true);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = form.file_name
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            alert('Error downloading file');
        }
    };

    const downloadFile = async () => {
        try {

            const timestamp = new Date().getTime();
            const response = await sendAPIRequest(`/api/indicator/download/${id}`);
            if (response.status !== 200) {
                throw new Error('Error downloading file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);


            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;


            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'default.pdf';

            if (contentDisposition && contentDisposition.includes('filename=')) {
                const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                if (fileNameMatch && fileNameMatch[1]) {
                    filename = fileNameMatch[1];
                }
            }

            a.download = filename;

            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            setIsDownload(true);
        } catch (error) {
            console.error('Download error:', error);
            alert('Error downloading file');
        }
    };

    const loadData = async () => {
        try {
            const req = await sendAPIRequest(`/api/indicator/${id}`);
            const res = await req.json();
            if (res.success) {
                setForm({ ...initialForm, ...res.data, updatedBy: userId });
            } else {
                displayNotification('error', `${t("925", "Error loading multilingual keyword data")} [B]`);
            }
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("925", "Error loading multilingual keyword data")} [F]`);
        }
    };

    const handleSave = async () => {
        const successKeyword = id == undefined ? t("216", "created") : t("217", "saved");
        const errorKeyword = id == undefined ? t("218", "creating") : t("219", "saving");
        const error = validator();
        if (error === false) {
            return;
        }
        try {
            if (
                window.confirm(
                    t("220", "You are about to save a record. Do you want to continue?")
                )
            ) {
                setRequestSent(true);

                const formData = new FormData();
                formData.append('indicator_name', form.indicator_name);
                formData.append('indicator_description', form.indicator_description);
                formData.append('indicator_use_purpose', form.indicator_use_purpose);

                if (id) {
                    formData.append('updatedBy', userId); // Ensuring `userId` is correctly used
                } else {
                    formData.append('user_id', userId);
                }

                if (file) {
                    formData.append('attachment', file);
                }

                const req = await sendAPIRequest(
                    id == undefined
                        ? `/api/indicator`
                        : `/api/indicator/${id}`,
                    id == undefined ? "POST" : "PUT",
                    formData // No need to JSON.stringify()
                );
                const res = await req.json();

                if (res.success) {
                    if (id == undefined) {
                        setForm({ ...initialForm });
                    }
                    displayNotification('success', `Successfully ${successKeyword} multilingual keyword`);
                } else {
                    displayNotification('error', `Error ${errorKeyword} multilingual keyword [B]`);
                }

                setRequestSent(false);
            }
        } catch (e) {
            setRequestSent(false);
            console.log(e);
            displayNotification('error', `Error ${errorKeyword} multilingual keyword [F]`);
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        setFileName(selectedFile.name);
    };

    const fileUpload = () => {
        const fileInput = document.getElementById('get-file');
        fileInput.accept = '.pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .txt';
        fileInput.click();
    }

    return (
        <>
            <div className="container my-2">
                <div className="header card-woah border border-secondary d-flex px-4 py-2 my-2 shadow-sm w-100">
                    <div className='d-flex justify-content-between w-100'>
                        <div className="card-title1 lh-1">
                            {id == undefined ? t("94", "Add New") : t("80", "Edit")}{" "}
                            {t("-1", "Indicator")}
                        </div>
                        <div className=''>
                            <button
                                className="btn btn--primary font-custom fs-6 ms-1"
                                onClick={() => navigate('/portal/indicator/index')}
                            >
                                {t("-1", "Back")}
                            </button>
                        </div>

                    </div>
                </div>
                <div className="header card-woah border border-secondary  px-4 py-2 shadow-sm w-100">
                    <div id="dropzone" className='border border-2 text-center mx-auto' style={{
                        height: '200px',
                        width: '200px',
                    }}>
                        <img id='upload-img' src={uploadDarkImage} className="w-75" alt='upload-file' />
                        <p>{t("33", "Drag and drop to upload file")}</p>
                    </div>
                    <div className='text-center'>
                        <label className="fw-bold">{fileName}</label>
                        <button
                            type='button'
                            className='btn btn--primary fs-7 lh-1 my-2 mx-auto d-block'
                            onClick={fileUpload}
                        >
                            {t("35", "Browse File")}
                        </button>
                        <input
                            type='file'
                            id="get-file"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />

                        {file==null && form.file_name != undefined && form.file_name !== "" && form.file_name != null && (

                            <>

                                <span
                                    className="fs-4 lh-1 mb-3 d-flex justify-content-center cursor-pointer"
                                    onClick={() => downloadFile()}
                                >
                                    <BsDownload className="text-primary" /> <span className="fw-bold mx-3">{form.file_name}</span>
                                </span>
                            </>

                        )}
                    </div>

                    <div className="row mt-8 ps-5">
                        <div className="row mb-3">
                            <div className="col-2">

                            </div>
                            <div className="col-2">
                                <label className="required">{t("-1", "Indicator Name")}</label>
                            </div>
                            <div className="col-6">
                                <TextFieldCustom
                                    type="text"
                                    className="form-control"
                                    required={false}
                                    value={form.indicator_name}
                                    onChange={(e) =>
                                        setForm({ ...form, indicator_name: e.target.value })
                                    }
                                    size="small"
                                />
                            </div>
                            <div className="col-2">

                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-2">

                            </div>
                            <div className="col-2">
                                <label className="required">{t("-1", "Description")}</label>
                            </div>
                            <div className="col-6">
                                <TextFieldCustom
                                    type="text"
                                    className="form-control"
                                    required={false}
                                    value={form.indicator_description}
                                    onChange={(e) =>
                                        setForm({ ...form, indicator_description: e.target.value })
                                    }
                                    fullWidth
                                    size="small"
                                    multiline
                                    rows={4}
                                />
                            </div>
                            <div className="col-2">

                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-2">

                            </div>
                            <div className="col-2">
                                <label className="required">{t("-1", "Use/Purpose")}</label>
                            </div>
                            <div className="col-6">
                                <TextFieldCustom
                                    type="text"
                                    className="form-control"
                                    required={false}
                                    value={form.indicator_use_purpose}
                                    onChange={(e) =>
                                        setForm({ ...form, indicator_use_purpose: e.target.value })
                                    }
                                    fullWidth
                                    size="small"
                                    multiline
                                    rows={4}
                                />
                            </div>
                            <div className="col-2">

                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 d-flex justify-content-center">
                                <button className="btn btn--primary" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Form;
